<div class="d-flex header">
    <div class="selected-project">
        <div>Project list</div>
        <div class="projects-sub-menu" style="position: absolute;top:45px;left: 0px;background-color: cadetblue;z-index: 500;cursor: pointer">        
            <div>Manage trees</div>
            <div>------------------</div>
            <ul>
                <li>Project 1</li>
                <li>Project 2</li>
                <li>Project 3</li>
            </ul>        
        </div>
    </div>
    
    <app-breadcrumb-trail></app-breadcrumb-trail>
</div>